import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Question1.css";
import QO1 from "./images/qo1.webp";
import QO2 from "./images/qo2.webp";
import QO3 from "./images/qo3.webp";
import QO4 from "./images/qo4.webp";
import Q1 from "./images/q1.webp";

const Question1 = ({ onAnswer, userResponse }) => {
  const [animateOut, setAnimateOut] = useState(false);

  const question = {
    title: "What is the most challenging part of writing a research paper?",
    questionImage: Q1,
    options: [
      { label: "Understanding the topic", image: QO1 },
      { label: "Collecting Data", image: QO2 },
      { label: "Writing the introduction", image: QO3 },
      { label: "Structuring the thesis", image: QO4 },
    ],
  };

  const handleNext = () => {
    if (!userResponse[question.title]) {
      return; 
    }

    setAnimateOut(true);
    setTimeout(() => {
      onAnswer(question.title, null);
    }, 1000);
  };

  return (
    <AnimatePresence>
      <motion.div
        className="question-container"
        initial={{ opacity: 0, x: "10%" }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: "-100vw" }}
        transition={{ duration: 1 }}
      >
        <motion.img
          className="question-img"
          src={question.questionImage}
          alt="Question"
          initial={{ opacity: 0, x: "10%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: "-100vw" }}
          transition={{ duration: 0.5 }}
        />

        <motion.h2
          className="question-head"
          initial={{ opacity: 0, x: "10%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: "-100vw" }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          {question.title}
        </motion.h2>

        <div className="option-container">
          {question.options.map((option, index) => (
            <motion.label
              key={index}
              className={`radio-option ${
                userResponse[question.title] === option.label ? "checked" : ""
              }`}
              htmlFor={`option-${index}`}
              initial={{ opacity: 0, x: "10%" }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: "-100vw" }}
              transition={{
                duration: 0.5,
                delay: 0.5,
              }}
            >
              <input
                type="radio"
                id={`option-${index}`}
                name={`question-${question.title}`}
                value={option.label}
                checked={userResponse[question.title] === option.label}
                onChange={() => onAnswer(question.title, option.label)}
              />
              <img
                className="option-img"
                src={option.image}
                alt={option.label}
              />
              <span className="radio-label">{option.label}</span>
            </motion.label>
          ))}
        </div>

        <motion.button
          type="submit"
          initial={{ opacity: 0, x: "10%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: "-100vw" }}
          transition={{ duration: 0.5, delay: 1 }}
          onClick={handleNext}
          disabled={!userResponse[question.title]} 
        >
          Next Question
        </motion.button>
      </motion.div>
    </AnimatePresence>
  );
};

export default Question1;
